import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { Enum } from './enum.resource';
import { Job } from './job.resource';
import { EndUserProviderJobConfig, FirmJobConfig } from 'src/app/shared/tools/search/search-config';
import { AtomService } from '../atom.service';
import { NumberFilter, StringFilter } from 'src/app/filter/filter';

@Resource({
  type: 'jobsiprangesversions',
})
export class JobsIPRangesVersions extends AtomResource {
  @Attribute() state?: Enum;
  @Attribute() data?: string;
  @Attribute() desc?: string;
  @Attribute({ key: 'previous_data' }) previousData?: string;
  @Attribute({ key: 'actual_data' }) actualData?: string;
  @Attribute({ key: 'normalized_data' }) normalizedData?: string;
  @Attribute({ key: 'cleaned_data' }) cleanedData?: string;
  @Attribute({ key: 'merged_data' }) mergedData?: string;
  @Attribute({ key: 'error_data' }) errorData?: string;
  @Attribute({ key: 'validity_tz' }) validityTz?: string;
  @Attribute() validity?: string;

  @Relationship() job?: Job;
  @Relationship() jobsiprangesversion?: JobsIPRangesVersions;
}

export class JobsIPRangesVersionsConfig implements ResourceConfig {

  tables = {
    includes: [
      'job.firm.headquarterscountry',
      'jobsiprangesversion',
    ],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        displayed: true,
      },
      {
        columnDef: 'validity',
        header: 'Validity',
        displayed: true,
      },
      {
        columnDef: 'state',
        displayedDatas: [{ path: ['state'], class: 'main' }],
        header: 'State',
        displayed: true,
      },
      {
        columnDef: 'firm',
        displayedDatas: [
          { path: ['job.firm.name'], class: 'main' },
          { path: ['job.firm.headquarterscountry.name'], class: 'main' },
        ],
        header: 'Job Firm',
        displayed: true,
        link: {
          resource: 'firms',
          filter: 'job.firm.id',
        },
        options: {
          flag: 'job.firm.headquarterscountry.id',
        },
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'http',
      options: {
        flag: 'job.firm.headquarterscountry.id',
      },
      title: [
        {
          path: ['job.firm.name'],
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: false,
        list: [
          {
            icon: 'business',
            title: 'Job Firm',
            APIKey: 'job',
            value: {
              path: ['job.firm.name'],
            },
            link: {
              resource: 'firms',
              filter: 'job.firm.id',
            },
          },
          {
            icon: 'http',
            title: 'Job IP Range Version',
            APIKey: 'jobsiprangesversion',
            value: {
              path: ['jobsiprangesversion.id'],
            },
            link: {
              resource: 'jobsiprangesversions',
              filter: 'jobsiprangesversion.id',
            },
          },
          {
            type: 'textarea',
            collapse: true,
            title: 'IP Ranges Data',
            APIKey: 'data',
            value: {
              path: ['data'],
            },
            options: {
              copy: true,
            }
          },
          {
            type: 'textarea',
            collapse: true,
            title: 'Normalized',
            APIKey: 'normalizedData',
            value: {
              path: ['normalizedData'],
            },
          },
          {
            type: 'data',
            collapse: true,
            title: 'Cleaned',
            APIKey: 'cleanedData',
            value: {
              path: ['cleanedData'],
            },
          },
          {
            type: 'textarea',
            collapse: true,
            title: 'Merged',
            APIKey: 'mergedData',
            value: {
              path: ['mergedData'],
            },
          },
        ]
      }
    ]
  };
  wizard = {
    noCloseAfterCreation: true,
    tabs: [
      {
        title: 'IP Ranges Data',
        formGroup: 'general',
        create: true,
        list: [
          {
            type: 'resource',
            title: 'Job Firm',
            APIKey: 'job',
            formControl: 'job',
            search: new EndUserProviderJobConfig(this.atom),
            required: true,
            noCols: true,
            filter: [
              {
                key: 'equal.activity.id',
                fixValue: '2',
              },
            ],
            options: {
              uniq: true,
            },
          },
          {
            type: 'textarea',
            title: 'Data to import',
            APIKey: 'data',
            formControl: 'data',
            required: true,
            noCols: true,
          }
        ]
      },
    ]
  };
  resource = JobsIPRangesVersions;
  resourceName = 'IP Range Version';
  resourceKey = 'jobsiprangesversions';
  resourceKeySingle = 'jobsiprangesversion';
  includes = [
    'job.firm.headquarterscountry',
    'jobsiprangesversion',
    'job.activity'
  ];
  filters = [
      new NumberFilter('id', 'ID'),
      new StringFilter('job.firm.headquarterscountry.id', 'Country ID', true),
      new StringFilter('job.firm.name', 'Firm Name'),
    ];

  constructor (private atom: AtomService) {}
}
